import {
  PiAirplaneTilt, PiBaby, PiBank, PiBarbell, PiBriefcase, PiBuildings, PiBus,
  PiCalendarDots, PiCar, PiCoins, PiConfetti, PiCreditCard, PiCurrencyDollar,
  PiDeviceMobile, PiDotsThree, PiDrop, PiFilmSlate, PiFirstAid, PiFirstAidKit,
  PiForkKnife, PiGameController, PiGasPump, PiGift, PiGraduationCap, PiHandCoins,
  PiHeart, PiHouse, PiKey, PiLaptop, PiLightning, PiMusicNotes,
  PiPaintBrushHousehold, PiPawPrint, PiPiggyBank, PiPill, PiReceipt, PiScissors,
  PiShieldCheck, PiShoppingCart, PiStorefront, PiTag, PiTicket, PiTrendUp,
  PiTShirt, PiUmbrella, PiWallet, PiWifiHigh, PiWrench,
} from 'react-icons/pi';

// Identificadores persistidos são estáveis e independem do nome exportado pelo Phosphor.
export const CATEGORY_ICON_COMPONENTS = Object.freeze({
  airplane: PiAirplaneTilt, baby: PiBaby, bank: PiBank, fitness: PiBarbell,
  briefcase: PiBriefcase, buildings: PiBuildings, bus: PiBus, calendar: PiCalendarDots,
  car: PiCar, coins: PiCoins, celebration: PiConfetti, creditCard: PiCreditCard,
  currency: PiCurrencyDollar, phone: PiDeviceMobile, more: PiDotsThree, water: PiDrop,
  film: PiFilmSlate, health: PiFirstAid, emergency: PiFirstAidKit, food: PiForkKnife,
  games: PiGameController, fuel: PiGasPump, gift: PiGift, education: PiGraduationCap,
  loan: PiHandCoins, care: PiHeart, house: PiHouse, key: PiKey, laptop: PiLaptop,
  energy: PiLightning, music: PiMusicNotes, homeCare: PiPaintBrushHousehold,
  pets: PiPawPrint, savings: PiPiggyBank, medicine: PiPill, receipt: PiReceipt,
  beauty: PiScissors, insurance: PiShieldCheck, shopping: PiShoppingCart,
  restaurant: PiStorefront, tag: PiTag, ticket: PiTicket, growth: PiTrendUp,
  clothes: PiTShirt, pension: PiUmbrella, wallet: PiWallet, internet: PiWifiHigh,
  services: PiWrench,
});

// FINANCIAL_CATEGORIES segue como catálogo; este mapa apenas define apresentação.
export const DEFAULT_CATEGORY_ICON_IDS = Object.freeze({
  'Alimentação': 'food',
  'Supermercado': 'shopping',
  'Restaurantes e Delivery': 'restaurant',
  'Transporte': 'bus',
  'Veículo': 'car',
  'Combustível': 'fuel',
  'Manutenção do Veículo': 'services',
  'Estacionamento e Pedágios': 'ticket',
  'Moradia': 'house',
  'Energia': 'energy',
  'Água': 'water',
  'Internet': 'internet',
  'Telefone': 'phone',
  'Condomínio': 'buildings',
  'Aluguel': 'key',
  'Financiamento': 'bank',
  'Casa e Manutenção': 'homeCare',
  'Educação': 'education',
  'Saúde': 'health',
  'Farmácia': 'medicine',
  'Academia': 'fitness',
  'Cuidados Pessoais': 'care',
  'Beleza': 'beauty',
  'Filhos': 'baby',
  'Pets': 'pets',
  'Lazer': 'games',
  'Entretenimento': 'film',
  'Eventos': 'celebration',
  'Viagens': 'airplane',
  'Assinaturas e Mensalidades': 'calendar',
  'Roupas e acessórios': 'clothes',
  'Compras': 'shopping',
  'Eletrônicos': 'phone',
  'Tecnologia': 'laptop',
  'Presentes e doações': 'gift',
  'Dívidas e Empréstimos': 'loan',
  'Seguros e Taxas': 'insurance',
  'Impostos': 'receipt',
  'Tarifas Bancárias': 'creditCard',
  'Investimentos': 'growth',
  'Poupança': 'savings',
  'Previdência': 'pension',
  'Reserva de Emergência': 'emergency',
  'Trabalho': 'briefcase',
  'Serviços': 'services',
  'Salário': 'currency',
  'Renda extra': 'coins',
  'Reembolsos': 'wallet',
  'Rendimentos': 'growth',
  'Outros': 'more',
});

export const CATEGORY_ICON_OPTIONS = Object.freeze([
  ['tag', 'Categoria'], ['food', 'Alimentação'], ['shopping', 'Compras'],
  ['restaurant', 'Restaurante'], ['car', 'Veículo'], ['bus', 'Transporte'],
  ['house', 'Casa'], ['services', 'Manutenção'], ['energy', 'Energia'],
  ['water', 'Água'], ['internet', 'Internet'], ['phone', 'Telefone'],
  ['education', 'Educação'], ['health', 'Saúde'], ['medicine', 'Farmácia'],
  ['fitness', 'Atividade física'], ['beauty', 'Cuidados pessoais'], ['baby', 'Filhos'],
  ['pets', 'Pets'], ['games', 'Lazer'], ['film', 'Entretenimento'],
  ['airplane', 'Viagens'], ['clothes', 'Roupas'], ['gift', 'Presentes'],
  ['creditCard', 'Cartão'], ['savings', 'Poupança'], ['briefcase', 'Trabalho'],
  ['growth', 'Investimentos'], ['music', 'Música'], ['calendar', 'Agenda'],
].map(([id, label]) => Object.freeze({ id, label, Icon: CATEGORY_ICON_COMPONENTS[id] })));

export const CATEGORY_COLOR_OPTIONS = Object.freeze([
  { id: 'default', label: 'Padrão', cssColor: 'var(--nf-category-neutral)' },
  { id: 'blue', label: 'Azul', cssColor: 'var(--nf-category-blue)' },
  { id: 'navy', label: 'Azul profundo', cssColor: 'var(--nf-category-navy)' },
  { id: 'mint', label: 'Verde', cssColor: 'var(--nf-category-mint)' },
  { id: 'coral', label: 'Coral', cssColor: 'var(--nf-category-coral)' },
  { id: 'amber', label: 'Dourado', cssColor: 'var(--nf-category-amber)' },
  { id: 'violet', label: 'Violeta', cssColor: 'var(--nf-category-violet)' },
  { id: 'slate', label: 'Cinza azulado', cssColor: 'var(--nf-category-slate)' },
]);

export const getCategoryIcon = ({ name, icon } = {}) => {
  const iconId = DEFAULT_CATEGORY_ICON_IDS[name] || icon;
  return CATEGORY_ICON_COMPONENTS[iconId] || PiDotsThree;
};

export const getCategoryColor = (colorToken) => (
  CATEGORY_COLOR_OPTIONS.find((option) => option.id === colorToken)?.cssColor
  || CATEGORY_COLOR_OPTIONS[0].cssColor
);

export const isCategoryIconId = (iconId) => Boolean(CATEGORY_ICON_COMPONENTS[iconId]);
export const isCategoryColorId = (colorId) => CATEGORY_COLOR_OPTIONS.some((option) => option.id === colorId);
